import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import { ReactComponent as DeleteRedIcon } from "../../../assets/delete_red_icon.svg";
import user_placeholder from "../../../assets/user-profile.jpg";
import { useSnack } from "../../../hooks/useSnack";
import studentServices from "../../../services/studentServices";
import Button from "../../Button";
import Modal from "../../Modal";

const DeleteStudentModal = forwardRef(({ onSubmit }, ref) => {
  const { t } = useTranslation();
  const { showSnack } = useSnack();
  const [isOpen, setIsOpen] = useState(false);
  const [student, setStudent] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useImperativeHandle(ref, () => ({
    openModal(student) {
      setStudent(student);
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const handleConfirm = async () => {
    setIsSubmitting(true);
    try {
      const res = await studentServices.unassignStudent(student.id);
      showSnack(res.message, "success");
      onSubmit();
      setIsOpen(false);
      setTimeout(() => {
        setIsSubmitting(false);
      }, 500);
    } catch (error) {
      setIsSubmitting(false);
      showSnack(error, "error");
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      header={
        <div className="flex items-center justify-between">
          <p className="flex items-center gap-2 text-red-500">
            <DeleteRedIcon className="h-4 w-4 text-red-500" />
            {t("delete")} {t("the_account")}
          </p>
        </div>
      }
      footer={
        <div className="flex items-center justify-end space-x-2">
          <Button color="white" variant="outlined" onClick={() => setIsOpen(false)} label={t("cancel")} />
          <Button
            className="w-36"
            color="red"
            disabled={isSubmitting}
            loading={isSubmitting}
            onClick={handleConfirm}
            label={t("delete")}
          />
        </div>
      }
    >
      {/* Modal Body Content */}
      <div className="flex items-center justify-between gap-6">
        <div className="flex w-64 flex-col items-center justify-center gap-2 rounded-xl bg-blue-200 p-3 py-5 dark:bg-dark-background">
          <img
            className="h-14 w-14 rounded-full object-cover"
            src={student?.image || user_placeholder}
            alt="user"
          />
          <p className="text-center text-sm dark:text-gray-100">{student?.name}</p>
        </div>
        <p className="text-start text-mutedText dark:text-dark-mutedText">
          {t("are_you_sure")}{" "}
          <span className="font-medium">
            {t("delete")} {student?.name} {t("question_mark")}
          </span>
        </p>
      </div>
    </Modal>
  );
});

export default DeleteStudentModal;
